import { message } from "antd";
import { KOT_PRINTER_SERVER } from "../Constant/AppConstants";

export const sendKOTPrintJob = async (printPayload: any): Promise<boolean> => {
  if (!printPayload) return true;
  try {
    const res = await fetch(`${KOT_PRINTER_SERVER}/print`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(printPayload),
    });
    if (!res.ok) {
      message.warning("KOT sent but printer returned an error.");
      return false;
    }
    return true;
  } catch (err) {
    console.error("Printer fetch error:", err);
    message.warning("Could not reach the local KOT printer server.");
    return false;
  }
};
